import { render } from "./app.vue?vue&type=template&id=0af06e1e&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=0af06e1e&lang=css"

import exportComponent from "/azp/agent/_work/1/s/frontend-financier/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__